import React from 'react';
import Header from '../../Shared/Header/Header';
import myPic from '../../../image/about/mypic.jpg'

const About = () => {
    return (
        <div>
            <Header></Header> 
            <div className='mx-auto py-36 max-w-xl text-center '>
                <img src={myPic} alt="" className='max-w-xs mx-auto rounded-full'/>
                <h1 className='text-3xl my-4'>Rayhan Mujumdar</h1>
                <p>welcome to my website,My name is Rayhan Mujumdar.I am a react web developer.My goal next 6 month is very hard work to development.i wish next 6 month make a own ecommerc website build and make a business.that's my simple goal.</p>
            </div> 
        </div>
    );
};

export default About;